import { useMutation } from '@tanstack/react-query';
import { UpdateProfileRequest } from '@/types/request/UpdateProfileRequest';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { queryClient } from '@/main.tsx';
import { User } from '@/models/User';

const useUpdateProfile = () => {
  const mutationFn = async (request: UpdateProfileRequest) => {
    return updateProfile(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export default useUpdateProfile;

async function updateProfile(request: UpdateProfileRequest): Promise<void> {
  try {
    await BackendClient.post<BackendSuccessResponse<User>>('/api/auth/profile', request);

    return;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while updating profile.');
  }
}
